export const methods = {
    async getIndividualPrices() {
        if (this.user) {
            const [mails, numbers] = await Promise.all([
                this.sendRequest('/activations/getMailIndividualPrices', 'get'),
                this.sendRequest('/activations/getPhoneIndividualPrices', 'get')
            ]);

            this.individualPrices.mails = Array.isArray(mails) && mails.length === 0 ? {} : mails;
            this.individualPrices.numbers = Array.isArray(numbers) && numbers.length === 0 ? {} : numbers;
        }
    },
    async loadData() {
        if (this.numbersSelected) {
            this.allData.byServices = await this.getServiceData();
        } else {
            this.allData.byMails = await this.getMailData();
        }

        await this.initAfterLoadData();
        await this.changeAnyOther();
        await this.renderData();
    },

    initAfterLoadData() {
        if (this.numbersSelected) {
            this.popularServices = this.allData.byServices.popularServices;
            this.services = Object.values(this.allData.byServices.services);
            this.banPositions = this.allData.byServices.banPositions;
        } else {
            this.popularMailServices = this.allData.byMails.popularMailServices;
            this.mailsServices = Object.values(this.allData.byMails.mails);
        }
    },

    async renderData() {
        if (this.numbersSelected) {
            if (this.allData.byServices['services'][this.selectedService.id]?.countries === undefined) {
                let countriesList = await this.sendRequest('/activations/getPricesByService', 'get', {serviceId: this.selectedService.id});
                this.serviceCountries = [];
                this.allData.byServices.services[this.selectedService.id] = {
                    countries: countriesList.services?.[this.selectedService?.id]?.countries
                };
            }

            let countries = this.allData.byServices['services'][this.selectedService.id].countries;
            this.sortAvailableCountriesList(countries);
            let total = [...Object.values(countries)];
            this.prepareCountryLabelsList(total);
        } else {
            if (this.allData.byMails['mails'][this.selectedService.id]?.rests === undefined) {
                let mailData = await this.sendRequest('/activations/getMailRestsByService', 'get', {serviceId: this.selectedService.id});
                this.mailDomains = [];
                this.allData.byMails.mails[this.selectedService.id] = {
                    rests: mailData.mails?.[this.selectedService?.id]?.rests
                };
            }

            let mails = this.allData.byMails['mails'][this.selectedService.id].rests
            let totalMails = [...Object.values(mails)];
            this.prepareCountryMailLabelsList(totalMails);

        }
    },

    async getServiceData() {
        if (sessionStorage.getItem(this.selectedServiceKey)) {
            this.selectedService = JSON.parse(sessionStorage.getItem(this.selectedServiceKey));
        }

        const data = {
            serviceId: this.selectedService.id,
            withPopular: true,
        };

        return await this.sendRequest('/activations/getPricesByService', 'get', data);
    },

    async getMailData() {
        if (sessionStorage.getItem(this.selectedServiceKey)) {
            this.selectedService = JSON.parse(sessionStorage.getItem(this.selectedServiceKey));
        }

        const data = {
            serviceId: this.selectedService.id,
            withPopular: true,
        };

        return await this.sendRequest('/activations/getMailRestsByService', 'get', data);
    },

    changeAnyOther() {
        if (this.numbersSelected) {
            this.popularServices = this.popularServices
                .map(item => item.id === 781 ? {
                    ...item,
                    title: this.getLocalization("ANY SMS"),
                    img_path: "/img/svg/services/ot_phone.svg?v=1"
                } : item)
                .sort((a, b) => (b.id === 781) - (a.id === 781));
        } else {
            this.popularMailServices = this.popularMailServices
                .map(item => item.id === 781 ? {
                    ...item,
                    title: this.getLocalization("ANY EMAIL"),
                    img_path: "/img/svg/services/ot_mail.svg?v=1"
                } : item)
                .sort((a, b) => (b.id === 781) - (a.id === 781));
        }

        this.processSelectedService();
    },
    selectNumbers(isMounted = false) {
        if (!isMounted) {
            sessionStorage.removeItem(this.selectedServiceKey);
        }
        sessionStorage.removeItem('isMailSelected');

        this.numbersSelected = true;
        this.mailsSelected = false;
        this.typeServices = 'services';

        this.processSelectedService();

        if (!this.allData.byServices) {
            this.loadData();
        } else {
            this.renderData();
        }
    },
    selectMails() {
        if (!sessionStorage.getItem('isMailSelected')) {
            sessionStorage.removeItem(this.selectedServiceKey);
            sessionStorage.setItem('isMailSelected', true);
        }

        this.numbersSelected = false;
        this.mailsSelected = true;
        this.typeServices = 'mailsServices';

        this.processSelectedService();

        if (!this.allData.byMails) {
            this.loadData();
        } else {
            this.renderData();
        }
    },


    clearSessionStorage() {
        sessionStorage.removeItem('selectedCountryId');
        sessionStorage.removeItem(this.selectedServiceKey);
        sessionStorage.removeItem('isMailSelected');
    },
    processVitrine() {
        if (sessionStorage.getItem('selectedCountryId') != null) {
            this.selectedCountryId = Number(sessionStorage.getItem('selectedCountryId'));
        }

        sessionStorage.setItem('lang', document.documentElement.lang);
    },
    handleResize() {
        window.addEventListener('resize', this.handleResize);

        this.windowWidth = window.innerWidth;
    },

    processSelectedService() {
        if (sessionStorage.getItem(this.selectedServiceKey)) {
            this.selectedService = JSON.parse(sessionStorage.getItem(this.selectedServiceKey));
        } else {
            this.selectedService = {
                activate_org_code: "tg",
                id: 5,
                title: "Telegram"
            }
        }
    },
    async sendRequestForNumber(data) {
        let response = await this.sendRequest('/web/stubs/handler_api.php', 'get', data);
        let now = Date.now();
        if (this.buyNumberModalIsOpen && response.includes('NO_NUMBERS') && now - this.startBuyNumberTime < this.maxWaitTime) {
            await new Promise(resolve => setTimeout(resolve, 2000));
            return this.sendRequestForNumber(data);
        }
        return response;
    },
    async buyPhoneNumber(maxPrice, countryCode, serviceCode = null, providerIds = null) {
        await this.checkLogIn();
        let service = serviceCode ?? this.selectedService.activate_org_code;
        let banInfo = this.isBanned(service, countryCode);

        if (banInfo) {
            this.blockModalBannedTo = banInfo.banned_to;
            this.blockModalIsOpen = true;
            return;
        }
        this.buyNumberModalIsOpen = true;
        this.startBuyNumberTime = Date.now();
        let cabinetUrl = this.phoneHistoryRoute;
        let data = {
            action: 'getNumber',
            service: service,
            country: countryCode,
            fixPrice: maxPrice,
            ...(providerIds && {providerIds})
        }
        let getNumber = await this.sendRequestForNumber(data);
        this.buyNumberModalIsOpen = false;
        if (getNumber.includes('ACCESS_NUMBER')) {
            await this.alertMessage(this.getLocalization('Done. You’ve gotten a number!'), 'info');
            if (window.location.href !== cabinetUrl) {
                sessionStorage.setItem(this.selectedServiceKey, JSON.stringify(this.selectedService));
                setTimeout(() => {
                    window.location.href = cabinetUrl;
                }, 1000);
            }
            this.$root.$emit('bought-number')
        } else if (getNumber.includes('NO_NUMBERS')) {
            await this.alertMessage(this.getLocalization('No numbers available yet'), 'error');
        } else if (getNumber.includes('NO_BALANCE')) {
            await this.alertMessage(this.getLocalization('No balance. Please top up your balance'), 'error');
            if (window.location.href !== this.topUpRoute) {
                sessionStorage.setItem('backUrlTopUp', window.location.href);
                setTimeout(() => {
                    window.location.href = this.topUpRoute;
                }, 1000);
            }
        }

    },
    async buyMail(domain, serviceCode) {
        await this.checkLogIn();
        let cabinetUrl = this.mailHistoryRoute + '#mail';
        let data = {
            service: serviceCode,
            domain: domain
        }
        let getMail = await this.sendRequest('/cabinet/client/mailhistory/getActivation', 'get', data);
        if (getMail.status === 1 && getMail.mail) {
            await this.alertMessage(this.getLocalization('Done. You’ve gotten an email'), 'info');
            if (window.location.href !== cabinetUrl) {
                sessionStorage.setItem(this.selectedServiceKey, JSON.stringify(this.selectedService));
                setTimeout(() => {
                    window.location.href = cabinetUrl;
                }, 1000);
            }
            this.$root.$emit('bought-mail')
        } else if (getMail.error.includes('No mails yet')) {
            await this.alertMessage(this.getLocalization('No mail available yet'), 'error');
        } else if (getMail.error.includes('Insufficient balance')) {
            await this.alertMessage(this.getLocalization('No balance. Please top up your balance'), 'error');
            if (window.location.href !== this.topUpRoute) {
                sessionStorage.setItem('backUrlTopUp', window.location.href);
                setTimeout(() => {
                    window.location.href = this.topUpRoute;
                }, 1000);
            }
        }
    },
    async buyBatchMailPage() {
        await this.checkLogIn();
        if (window.location.href !== this.buyBatchMailRoute) {
            setTimeout(() => {
                window.location.href = this.buyBatchMailRoute;
            }, 1000);
        }
    },
    searchServicesFunc(newVal) {
        if (!newVal) {
            return this.searchServices = '';
        }
        this.searchServices = newVal;
    },
    async checkLogIn() {
        if (!this.user) {
            window.location.href = this.registrationRoute;
            await new Promise(resolve => setTimeout(resolve, 4000));
        }
    },
    prepareCountryLabelsList(countries) {
        countries = this.rateSort(countries);
        let preparedCountryList = [...countries];
        this.serviceCountries = preparedCountryList;
        if (this.searchCountries) {
            this.serviceCountries = preparedCountryList.filter((x) => x.alternative_title_locale.toLowerCase().includes(this.searchCountries.toLowerCase()));
        } else {
            this.serviceCountries = preparedCountryList;
        }
    },
    prepareCountryMailLabelsList(countries) {
        countries = this.rateSort(countries);
        let preparedCountryList = [...countries];
        this.mailDomains = preparedCountryList;
        if (this.searchCountries) {
            this.mailDomains = preparedCountryList.filter((x) => x.domain?.front_name?.toLowerCase().includes(this.searchCountries.toLowerCase()));
        } else {
            this.mailDomains = preparedCountryList;
        }
    },
    sortAvailableCountriesList(obj) {
        Object.keys(obj).forEach(key => {
            obj[key]['positions'] = this.sortTop(obj[key]['positions'], 'price');
        });
    },
    rateSort(countries) {
        return countries.sort((a, b) => {
            return this.rateSortFunc(a, b);
        });
    },
    rateSortFunc(a, b) {
        const rateA = a.rate !== null ? parseFloat(a.rate) : 9999;
        const rateB = b.rate !== null ? parseFloat(b.rate) : 9999;

        return rateA - rateB;
    },
    clearVueApp() {
        document.getElementById('not-loaded')?.remove();
    },
    async changeSelectedService(service) {
        this.selectedService = {
            id: service['id'],
            title: service['title'],
            activate_org_code: service['activate_org_code']
        }

        sessionStorage.setItem(this.selectedServiceKey, JSON.stringify(this.selectedService));
        this.selectedCountryId = null;
        sessionStorage.removeItem('selectedCountryId');

        this.serviceRouteSlug = this.allData.byServices?.services[this.selectedService.id]?.slug || 'telegram';
        await this.renderData();
    },
    changeFocusSearchService(val) {
        this.isFocusSearchService = val;
    },
    changeOpenCounties(id) {
        this.selectedCountryId = this.selectedCountryId === id ? null : id;
        sessionStorage.setItem('selectedCountryId', this.selectedCountryId);
    },
    sortPosition(country, type) {
        if (country.sort === undefined || country.sort.type !== type) {
            country.sort = {
                type: type,
                sortBy: 'top'
            };
        }
        country.sort.sortBy = country.sort.sortBy === 'top' ? 'bottom' : 'top';
        const sortedPositions = country.sort.sortBy === 'top' ?
            this.sortTop(country.positions, type) :
            this.sortBottom(country.positions, type);

        country.positions = [...sortedPositions];
    },
    sortTop(obj, type) {
        return Object.values(obj).sort((a, b) => b[type] - a[type]);
    },
    sortBottom(obj, type) {
        return Object.values(obj).sort((a, b) => a[type] - b[type]);
    },
    handlePrevSelectedService() {
        let selectedService = sessionStorage.getItem(this.selectedServiceKey);
        if (selectedService) {
            this.selectedService = JSON.parse(selectedService);
        }
    },
    isBanned(serviceCode, countryCode) {
        if (this.banPositions[serviceCode]) {
            return this.banPositions[serviceCode].find(el => el.activate_org_code === countryCode) || null;
        }
        return false;
    }
}